import { render, staticRenderFns } from "./home-search-sta.vue?vue&type=template&id=63e7a1b4&scoped=true&"
import script from "./home-search-sta.vue?vue&type=script&lang=js&"
export * from "./home-search-sta.vue?vue&type=script&lang=js&"
import style0 from "./home-search-sta.vue?vue&type=style&index=0&id=63e7a1b4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e7a1b4",
  null
  
)

export default component.exports